import { FunctionComponent, Fragment } from 'react';
import MaintenanceState from '@adsk/acc-maintenance-state';
import { T } from '../helpers/i18n';

import { useGetRfisMaintenanceMode } from '../hooks/useGetRfisMaintenanceMode';

const MaintenanceMode: FunctionComponent = ({ children }) => {
  const isMaintenanceMode = useGetRfisMaintenanceMode();

  if (isMaintenanceMode) {
    return <MaintenanceState name={T.translate('rfis.label_plural') as string} />;
  }
  return <Fragment>{children}</Fragment>;
};

export default MaintenanceMode;
